<template>
  <div class="archive">
    <div class="timeline">
      <div class="count">{{this.$route.params.name || "全部"}}：{{pageTotal}}{{"篇"}}</div>
      <el-timeline>
        <el-timeline-item v-for="(activity, index) in articleList" :key="index" :color="activity.color" :timestamp="activity.createTime" placement="top" @mouseenter="hoverLine(activity)">
          <div class="line-item">
            <router-link :to="'/article/'+activity.id">{{activity.articleName}}</router-link>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div style="text-align:center;margin-top:30px">
      <div style="display:inline-block; float:none">
        <el-pagination v-if="paginationShow" ref="pagination" background layout="prev, pager, next" :current-page.sync="currentPage" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "archive",
  data() {
    return {
      currentCategoryId: 0,
      currentPage: 1,
    };
  },
  computed: {
    categoryList() {
      return this.$store.state.categoryList;
    },
    articleList() {
      return this.$store.state.articleList;
    },
    pageTotal() {
      return this.$store.state.totalArticleNum;
    },
    paginationShow() {
      return this.$store.state.articleList.length === 0 ? false : true;
    },
  },
  created() {
    this.$store.commit("setActiveIndex", "/archive");
    var tagName = this.$route.params.name;
    if (tagName !== undefined) {
      this.currentCategoryId = this.queryCategoryId(tagName);
    }

    this.$store.commit("queryCategoryInfoList");
    this.$store.commit("queryArticleList", {
      categoryId: this.currentCategoryId,
      page: this.currentPage,
      searchParam: "",
    });

    window.scroll(0, 0);
  },
  methods: {
    hoverLine(activity) {
      activity.color = "#409eff";
    },
    // 分页导航
    handlePageChange(val) {
      console.log(val);
      this.currentPage = val;
      this.$store.commit("queryCategoryInfoList");
      this.$store.commit("queryArticleList", {
        categoryId: this.currentCategoryId,
        page: this.currentPage,
        searchParam: "",
      });
      window.scroll(0, 0);
    },
    queryCategoryId(tagName) {
      for (var i = 0; i < this.categoryList.length; i++) {
        if (this.categoryList[i].categoryName === tagName) {
          return this.categoryList[i].id;
        }
      }
      return 0;
    },
  },
};
</script>

<style scoped>
.timeline {
  padding-left: 10%;
}

.line-item {
  display: inline-block;
}

.line-item:hover {
  cursor: pointer;
  color: #409eff;
}

.count {
  margin-bottom: 20px;
  font-size: 20px;
  color: #e6a23c;
}
</style>